import { WeekTimeRecord, WeekTimeRecordsScope } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type WeekTimeRecordResponse = {
  uuid: string;
  recordingDate: string;
  timeSpent: number;
  attributes: { [key: string]: string } | null;
  resourceUuid: string;
  resourceName: string;
  resourceIntegratedAt: string | null;
  taskUuid: string;
  taskName: string;
  projectUuid: string;
  projectName: string;
  projectIntegratedAt: string | null;
  zoneUuid: string;
  zoneName: string;
  zoneColor: string | null;
};

function getWeekTimeRecords(httpClient: HttpClient) {
  return (scope: WeekTimeRecordsScope, startDate: string, endDate: string) =>
    httpClient
      .sendHttpRequest<WeekTimeRecordResponse[]>({
        endpoint: "/timesheet/timeRecords/week",
        method: HttpMethods.POST,
        data: { ...scope, startDate, endDate },
      })
      .then((records) =>
        records.map(
          (record): WeekTimeRecord => ({
            uuid: record.uuid,
            recordingDate: record.recordingDate,
            timeSpent: record.timeSpent,
            attributes: record.attributes || {},
            resource: {
              uuid: record.resourceUuid,
              name: record.resourceName,
              integratedAt: record.resourceIntegratedAt ?? undefined,
            },
            task: { uuid: record.taskUuid, name: record.taskName },
            project: {
              uuid: record.projectUuid,
              name: record.projectName,
              integratedAt: record.projectIntegratedAt ?? undefined,
            },
            zone: {
              uuid: record.zoneUuid,
              name: record.zoneName,
              color: record.zoneColor || "",
            },
          }),
        ),
      );
}

export { getWeekTimeRecords };
